<template>
  <div
    class="modal fade"
    id="modal"
    ref="modal"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="bg-body-secondary modal-header py-2">
            {{ $t('Record Usage') + ': ' + name }}
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div
          class="modal-body"
          v-if="loading"
        >
          <placeholder-content :is-load="true" />
        </div>
        <div
          class="modal-body"
          v-else
        >
          <div
            class="overflow-x-auto"
          >
            <table class="mb-0 mt-3 table table-sm">
              <thead
                class="table-light"
                style="font-size: 14px;"
              >
                <tr>
                  <th
                    style="min-width: 180px;"
                  >
                    {{ $t('Lot No.') }}
                  </th>
                  <th
                    style="min-width: 100px;"
                  >
                    {{ $t('Expiry Date') }}
                  </th>
                  <th
                    class="text-end"
                    style="min-width: 100px;"
                  >
                    {{ $t('Stock Available') }}
                  </th>
                  <th
                    class="text-end"
                    style="min-width: 100px;"
                  >
                    {{ $t('Used') }}
                  </th>
                  <th
                    class="text-end"
                    style="min-width: 100px;"
                  >
                    {{ $t('Used Quantity') }}
                  </th>
                  <th
                    style="min-width: 80px;"
                  >
                    {{ $t('Unit') }}
                  </th>
                </tr>
              </thead>
              <tbody
                style="font-size: 14px;"
              >
                <tr
                  v-for="(allocation, index) in form.allocations"
                >
                  <item-record-lot
                    :index="index"
                    :allocation="allocation"
                  />
                </tr>
                <tr
                  v-if="form.allocations.length == 0"
                >
                  <td
                    colspan="6"
                    class="text-center"
                  >
                    {{ $t('No Available Data') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="text-end"
          >
            {{ $t('Total Used') + ': ' }}
            <b>
              {{ (totalUsed? formatNumberTwoDigit(totalUsed): '0.00') + ' ' + $t(unit) }}
            </b>
          </div>
        </div>
        <div
          class="modal-footer py-2"
          v-if="!loading"
        >
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ $t('Close') }}
          </button>
          <ladda
            text="Confirm"
            :btn-class="'btn btn-sm btn-theme'"
            :disabled="v$.$invalid || this.totalUsed == 0"
            @click="handleConfirm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-record";
import { InventoryProductionBatches } from '@/services/endpoint/inventory-production-batches.service';
import moment from "moment";
import numeral from 'numeral';
import ItemRecordLot from './ItemRecordLot.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    inventoryId: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
  },
  data() {
    let vm = this;
    return {
      loading: true,
      form: {
        allocations: []
      }
    }
  },
  components: {
    Ladda,
    PlaceholderContent,
    ItemRecordLot
  },
  methods: {
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD');
    },
    async fetchData() {
      var queryString = '?' + $.param({
        inventory_production_batch_input_id: this.id
      });
      let self = this;
      await InventoryProductionBatches.getRecord(this.$parent.id, queryString).then(res => {
        self.form.allocations = res.data.data.lots.map(function(allocation) {
          return {
            inventory_production_batch_input_id: self.id,
            lot_number: allocation.lot_number,
            expiry_date: allocation.expiry_date,
            inventory_lot_id: allocation.id,
            remaining_quantity: allocation.remaining_quantity,
            currently_used: allocation.currently_used,
            actual_quantity: '',
            actual_cost_per_unit: allocation.cost,
            actual_total_cost: '',
            unit_id: allocation.unit_id,
            unit: allocation.unit,
          }
        });
      }).catch(err => {
			  throw err;
      });
    },
    async handleConfirm() {
      this.v$.$touch();
      if(this.v$.$invalid || this.totalUsed == 0) {
        return;
      }
      let params = _.cloneDeep(this.form);
      params.allocations = params.allocations.filter(function(obj) {
        return obj.actual_quantity != '';
      }).map(function(allocation) {
        return {
          inventory_production_batch_input_id: allocation.inventory_production_batch_input_id,
          inventory_lot_id: allocation.inventory_lot_id,
          actual_quantity: allocation.actual_quantity,
          actual_cost_per_unit: allocation.actual_cost_per_unit,
          actual_total_cost: allocation.actual_total_cost,
          unit_id: allocation.unit_id
        }
      });
      let total = (this.totalUsed? this.formatNumberTwoDigit(this.totalUsed): '0.00') + ' ' + this.$t(this.unit);
      let actualTotalCost = params.allocations.reduce((sum, value) => {
        return sum + (value.actual_total_cost*1);
      }, 0);
      try {
        let self = this;
        let title = this.$t("Final Confirmation");

        let html = this.$t(`Are you sure you want to deduct stock for`);
            html+= ' <b>' + this.name + '</b>?<br><br>' + this.$t('Total Quantity') + ': <b style="font-size: 1.2em; color: #1890ff;">' + total + '</b><br><br><small>' + this.$t('Inventory will be reduced immediately.') + '</small>';
        let confirmButtonText = this.$t("Yes, Deduct Now");
        let cancelButtonText = this.$t("Review Again");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: cancelButtonText,
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          reverseButtons: true,
          focusCancel: true,
          customClass: {
            confirmButton: "btn btn-theme",
            cancelButton: "btn btn-danger me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return InventoryProductionBatches.record(self.$parent.id, params)
              .then((response) => {
                self.$emit('update-usage', {
                  id: self.id,
                  used: self.totalUsed,
                  actualTotalCost: actualTotalCost
                });
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Record Batches Success!'));
                $(self.$refs.modal).modal('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.modal).modal('show');

    $(this.$refs.modal).on('shown.bs.modal',async () => {
      this.loading = true;
      try {
        await this.fetchData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.$parent.modalRecordLotForm.open = false;
    });
  },
  computed: {
    totalUsed() {
      return this.form.allocations.reduce((sum, value) => {
        return sum + (value.actual_quantity*1);
      }, 0);
    }
  }
}
</script>
